// Currently, Notification settings names are stored in the back-end in English.
// However, we want to translated these strings in the mobile client.
// We can use this util to do this.
export const getNotificationSettingsTranslation = function (name) {
    const notificationSettingsTranslations = {
        comments: _t('mobile_tasks_tab_title_comments'),
        alerts: _t('mobile_settings_notifications_sub_category_alerts'),
        new_forms: _t('mobile_settings_notifications_sub_category_new_forms_available'),
        task_assigned: _t('mobile_settings_notifications_sub_category_task_assigned'),
        task_completed: _t('mobile_settings_notifications_sub_category_task_completed'),
        tasks_due_soon: _t('mobile_settings_notifications_sub_category_tasks_due_soon_reminder'),
        tasks_due_soon_reminder: _t('mobile_settings_notifications_sub_category_tasks_due_soon_reminder'),
        overdue_tasks: _t('mobile_settings_notifications_sub_category_overdue_tasks_reminder'),
        announcements: _t('mobile_left_menu_announcements'),
        sensor_alerts: _t('mobile_settings_notifications_sub_category_sensor_alerts'),
        critical_sensor_alerts: _t('mobile_settings_notifications_sub_category_critical_sensor_alerts')
    };
    return notificationSettingsTranslations[name];
};
